import { render, staticRenderFns } from "./Status.vue?vue&type=template&id=ddfc3b9c&scoped=true"
import script from "./Status.vue?vue&type=script&lang=js"
export * from "./Status.vue?vue&type=script&lang=js"
import style0 from "./Status.vue?vue&type=style&index=0&id=ddfc3b9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddfc3b9c",
  null
  
)

export default component.exports